import React from 'react';
import { NavLink } from "react-router-dom";


class ListItem extends React.Component {

	render() {

		const { url, children } = this.props;

		return (
			<div className="list__item">
                <NavLink to={url} activeClassName="active">
                    {children}
				</NavLink>
		    </div>
      	)
	}
}


export default ListItem


// WEBPACK FOOTER //
// ./src/components/ListItem.js